// extracted by mini-css-extract-plugin
module.exports = {"footer":"cd2827bb bt b--black-10","footerBlockLogo":"_802b5507 pt3","footerMenuTitle":"_1b8c0a9f","srOnly":"e13b5dae","link":"df995acb no-underline pr1"};